interface AuthLoadingProps {
  message?: string
}

export function AuthLoading({ message = 'Conectando...' }: AuthLoadingProps) {
  return (
    <div className="flex h-screen items-center justify-center bg-(--color-bg-primary)">
      <div className="text-center">
        <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-2 border-(--color-border) border-t-(--color-primary)" />
        <p className="text-sm text-(--color-text-secondary)">{message}</p>
      </div>
    </div>
  )
}
